module.exports = __webpack_public_path__ + "static/006-healthy-7c39f8a9345d52856aa9ecaad215fbf1.png";